import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=1ec5755a"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec5755a')) {
      api.createRecord('1ec5755a', component.options)
    } else {
      api.reload('1ec5755a', component.options)
    }
    module.hot.accept("./UploadForm.vue?vue&type=template&id=1ec5755a", function () {
      api.rerender('1ec5755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/UploadForm.vue"
export default component.exports